import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Play } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export const HomeWelcomeBanner: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Time of day greeting
  const hour = new Date().getHours();
  let greeting = 'Olá';
  if (hour >= 5 && hour < 12) greeting = 'Bom dia';
  else if (hour >= 12 && hour < 18) greeting = 'Boa tarde';
  else greeting = 'Boa noite';

  const displayName = user?.username || 'Candidato';

  return (
    <div className="rounded-xl border border-paper-300 bg-paper-100 p-6 sm:p-7 shadow-sm dark:border-study-line dark:bg-study-panel transition-colors">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-5">
        <div>
          <div className="flex items-center gap-2 text-xs text-zinc-500 dark:text-zinc-400">
            <span className="h-2 w-2 rounded-full bg-study-teal-500" />
            <span>IFF Campos Centro · Vestibular 2027</span>
          </div>
          <h1 className="mt-1.5 font-serif text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">
            {greeting}, <span className="font-serif font-normal text-zinc-700 dark:text-zinc-300">{displayName}</span>
          </h1>
          <p className="mt-1 text-xs text-zinc-600 dark:text-zinc-400">
            Estação de treino deliberado para Matemática (Peso 5) e Ciências da Natureza (Peso 2).
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('/triagem')}
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-study-teal-700 px-5 py-2.5 text-xs font-semibold text-white shadow hover:bg-study-teal-800 active:scale-[0.99] dark:bg-study-teal-500 dark:text-study-slate dark:hover:bg-study-teal-400 transition"
          >
            <Play className="h-3.5 w-3.5 fill-current" />
            Iniciar Triagem
            <ArrowRight className="h-3.5 w-3.5 ml-0.5" />
          </button>
        </div>
      </div>
    </div>
  );
};
